// Global Types
import type {
  $TrackerRouteResponse as $ApiRouteResponse,
} from 'common.types';

// Service
import TrackerService from '../TrackerService';

// Types
import type {
  $Config,
} from '../TrackerService';

class TrackerServiceMock extends TrackerService<$Config> {
  constructor(config: $Config) {
    super(config);

    this.initMock((mock) => {
      mock.onGet(this.path('/position/get_many')).reply(() => {
        const responseBody: $ApiRouteResponse<'/position/get_many'> = [];

        return [200, responseBody];
      });
    });
  }
}

export default TrackerServiceMock;
